module.exports = __webpack_public_path__ + "static/img/Corey-Oates.16fe3c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Corey-Oates.jpg
// module id = 5IiA
// module chunks = 0